import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { apiGoogleSession } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    apiGoogleSession(sid)
      .then((data) => {
        loginWithToken(data.token, data.user);
        toast.success(`Welcome, ${data.user.name?.split(" ")[0] || "back"}!`);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-obsidian-900 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-gold animate-spin mx-auto" />
        <p className="text-slate-400 text-sm mt-3">Signing you in…</p>
      </div>
    </div>
  );
}
